// extracted by mini-css-extract-plugin
module.exports = {"userBtn":"user-button-component_userBtn__y0frX","logged":"user-button-component_logged__3e_c7"};